/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import {
  AnimalCategoryService,
  AnimalDetailPriceService,
  AnimalDetailService,
  AnimalGenderService,
  AnimalService,
  AnimalSpeciesService,
  AnimalTypeService,
  AtmService,
  AuthService,
  AutopsyService,
  CountryService,
  ExternalImportRemovalService,
  I18nService,
  PaymentTypeService,
  PrintService,
  RemovalPointService,
  RemovalService,
  ThirdPartyService,
  TownshipService,
  UserService
} from './services';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  exports: [],
  providers: [
    AnimalService,
    AnimalCategoryService,
    AnimalDetailService,
    AnimalDetailPriceService,
    AnimalGenderService,
    AnimalSpeciesService,
    AnimalTypeService,
    AtmService,
    AuthService,
    AutopsyService,
    CountryService,
    ExternalImportRemovalService,
    I18nService,
    PaymentTypeService,
    PrintService,
    RemovalService,
    RemovalPointService,
    ThirdPartyService,
    TownshipService,
    UserService
  ]
})

export class ServicesModule {

  constructor(@Optional() @SkipSelf() parentModule: ServicesModule) {
    if (parentModule) {
      throw new Error('ServicesModule is already loaded. Import your base AppModule only.');
    }
  }

}
